import { render, staticRenderFns } from "./live-boxs.vue?vue&type=template&id=4210b15f&scoped=true&"
import script from "./live-boxs.vue?vue&type=script&lang=js&"
export * from "./live-boxs.vue?vue&type=script&lang=js&"
import style0 from "./live-boxs.vue?vue&type=style&index=0&id=4210b15f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4210b15f",
  null
  
)

export default component.exports